module.exports = __webpack_public_path__ + "img/approved.43335d1c.png";